import styled from '@emotion/styled';
import { captionM, tag1Sb } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.section`
  display: flex;
  padding: 16px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  background: #e7f6f0;
`;

export const TextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const LeftText = styled.div`
  ${tag1Sb};
  font-weight: 600;
  color: ${vars.neutral[80]};

  ${DESKTOP} {
    ${captionM};
    font-weight: 600;
    color: ${vars.neutral[80]};
  }
`;

export const RightText = styled.div<{ isLast?: boolean }>`
  ${tag1Sb};
  font-weight: 600;
  color: ${(props) => (props.isLast ? vars.neutral[100] : '#009F65')};

  ${DESKTOP} {
    ${captionM};
    font-weight: 600;
    color: ${(props) => (props.isLast ? vars.neutral[100] : '#009F65')};
  }
`;
